import React, { useEffect, useReducer, useState } from 'react';
import {
  ClientRegistrationContainer,
  ClientRegistrationWrapper,
  ClientRegistrationContent,
  ClientRegistrationHeader,
  ClientRegistrationHeaderArea,
  ClientRegistrationHeaderTitle,
} from './styles';
import { useHistory, useLocation } from 'react-router';
import { H4, P } from '../../components/Typography/styles';
import { ClientRegistrationContext } from '../../store/';
import IdentityPhoto from './IdentityPhoto';
import ClientPhoto from './ClientPhoto';
import Registration from './Registration';
import AditionalData from './AditionalData';
import ProspectingClient from './ProspectingClient';
import Conformity from './Conformity';
import clientRegistrationReducer from '../../store/ClientRegistration';
import INITIAL_STATE_CLIENT_REGISTRATION from '../../store/ClientRegistration/state';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import Copyright from '../../components/Copyright';
import { getSimulacionById } from '../../services/simulation';
import { clientRegistrationSteps } from '../../helpers/enum';
import ModalActionCongratulations from '../../components/ModalActionCongratulations';
import colors from '../../assets/styles/colors';
import FormSteps from '../../components/FormSteps';
import Loader from '../../components/Loader';
import { default as ClientRegistrationTypes } from '../../store/ClientRegistration/types';
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import { getClientDataFull } from '../../services/clients';

const ClientRegistrationPage = () => {
  const history = useHistory();
  const location = useLocation();
  const [clientRegistration, setClientRegistration] = useReducer(clientRegistrationReducer, INITIAL_STATE_CLIENT_REGISTRATION);
  const [showSteps, setShowSteps] = useState(true);
  const [activeStep, setActiveStep] = useState(clientRegistrationSteps.IDENTITY_FOTO);
  const [lastStep, setLastStep] = useState(clientRegistrationSteps.DEFAULT);
  const [title, setTitle] = useState('Registro de Cliente');
  const [subTitle, setSubTitle] = useState('Clientes');
  const [habeasClientError, setHabeasClientError] = useState('');
  const [showHabeasClientModal, setShowHabeasClientModal] = useState(false);
  const [showHabeasClientError, setShowHabeasClientError] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  async function initializedStateComponent() {
    try {
      if(location.idCredit && location.client && !location.step) {
        return history.push({
          pathname: '/admin/global-debit',
          idCredit: location.idCredit,
          client: location.client
        });
      }

      if (!location.idSimulation && !location.idCredit) {
        return history.push('/admin/dashboard');
      }

      if(location.step) {
        setActiveStep(location.step);
      }

      // if(location.alertComplience) {
      //   setShowConformityModalVerified(true);
      // }

      // if(location.validatingComplience) {
      //   setShowConformityModal(true);
      // }

      if(location.idSimulation) {
        const response = await getSimulacionById(location.idSimulation);

        setClientRegistration({
          type: ClientRegistrationTypes.SET_SIMULATION_DATA,
          data: response.data
        })
      }
      
      if(location.idCredit) {
        const creditResponse = await getCreditById(location.idCredit);
        const solicitationResponse = await getSolicitationById(location.idCredit);

        solicitationResponse.data.simulacion = {
          ...solicitationResponse.data.simulacion,
          idAsesor: creditResponse.data.idAsesorPrincipal
        }

        const data = {
          idCredito: solicitationResponse.data.credito.id,
          idCliente: solicitationResponse.data.cliente.id,  
        }

        await setClientRegistration({
          type: ClientRegistrationTypes.SET_CREDIT_ID,
          data
        })

        await setClientRegistration({
          type: ClientRegistrationTypes.SET_SOLICITATION_DATA,
          data: solicitationResponse.data
        })

        if(solicitationResponse.data && solicitationResponse.data.cliente) {
            const clientResponse = await getClientDataFull(solicitationResponse.data.cliente.tipoIdentificacion, solicitationResponse.data.cliente.identificacion);
          
          await setClientRegistration({
            type: ClientRegistrationTypes.SET_EXISTING_CLIENT_DATA,
            data: clientResponse.data
          })
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function setReturnToRadicar() {
    return history.push('/admin/dashboard');
  }

  function skipToMainPage() {
    
  }

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (time > 0 && showOtpModal) {
  //       setTimeWidth(oldTimeWididth => oldTimeWididth + (100 / time));
  //       setTime(oldTime => oldTime - 1);
  //     }
  //   }, 1000);
  // }, [time])

  useEffect(() => { 
    switch(activeStep) {
      case clientRegistrationSteps.CONFORMITY:
        setShowSteps(false);
        setTitle('Prospección cliente');
        setSubTitle('');
        break;
      case clientRegistrationSteps.PROSPECTING:
        setTitle('Prospección cliente');
        setSubTitle('');
        setShowSteps(false);
        setShowHabeasClientModal(true);
        break;
      default:
        setSubTitle('Clientes');
        setTitle('Registro de Cliente');
        setShowSteps(true);
      break;
    }
  }, [activeStep]);

  useEffect(() => {
    if(clientRegistration.simulacion && isLoading) {
      setIsLoading(false);
    }
  }, [clientRegistration])

  useEffect(() => {
    initializedStateComponent();
  }, [])

  return (
    <ClientRegistrationContainer id="registration-page">
      {isLoading ? <Loader /> : (
        <ClientRegistrationWrapper>
          <ClientRegistrationHeader>
            <ClientRegistrationHeaderTitle>{subTitle}</ClientRegistrationHeaderTitle>
            <ClientRegistrationHeaderArea>
              <H4 color={colors.textPrimary}>{title}</H4>
              <P bold color={colors.textPrimary}>
                {clientRegistration.cliente?.nombres} {clientRegistration.cliente?.tipoIdentificacion.toUpperCase()}. {clientRegistration.cliente?.identificacion}
              </P>
            </ClientRegistrationHeaderArea>
          </ClientRegistrationHeader>

          <ClientRegistrationContent showSteps={showSteps} id="registration-steps">
            {showSteps && (
              <FormSteps lastStep={lastStep} steps={[
                {number: clientRegistrationSteps.IDENTITY_FOTO, label: 'Foto de la cédula'},
                {number: clientRegistrationSteps.REGISTRATION, label: 'Registro del cliente'},
                //{number: clientRegistrationSteps.ADITIONAL_DATA, label: 'Datos adicionales'},
                //{number: clientRegistrationSteps.CLIENT_PHOTO, label: 'Foto del cliente'}
              ]} />
            )}
            
            <ClientRegistrationContext.Provider value={{ clientRegistration, setClientRegistration }}>
              {activeStep === clientRegistrationSteps.IDENTITY_FOTO && (
                <IdentityPhoto setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === clientRegistrationSteps.REGISTRATION && (
                <Registration setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
 
              {/*activeStep === clientRegistrationSteps.ADITIONAL_DATA && (
                <AditionalData setActiveStep={setActiveStep} setLastStep={setLastStep} setReturnToRadicar={setReturnToRadicar}/>
              )*/}
  

              {/*activeStep === clientRegistrationSteps.CLIENT_PHOTO && (
                <ClientPhoto setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )*/}  

              {activeStep === clientRegistrationSteps.PROSPECTING && (
                <ProspectingClient
                  setLastStep={setLastStep}
                  setTitle={setTitle}
                  setSubTitle={setSubTitle}
                  setShowSteps={setShowSteps}
                  open={showHabeasClientModal}
                />
              )}

              {activeStep === clientRegistrationSteps.CONFORMITY && (
                <Conformity 
                  setActiveStep={setActiveStep} 
                  setLastStep={setLastStep}
                  setShowSteps={setShowSteps}
                  setTitle={setTitle}
                  setSubTitle={setSubTitle} />
              )}

              {

              }
            </ClientRegistrationContext.Provider>
          </ClientRegistrationContent>
        </ClientRegistrationWrapper>
      )}
       
      <ModalActionCongratulations
        open={showSuccessModal}
        setShowModal={setShowSuccessModal}
        actionFunctionUpButton={() => skipToMainPage()}
        title="¡Felicitaciones!"
        actionLabelFunctionUpButton="Continuar"
        description="Se ha generado el cliente correctamente. Se le ha enviado un correo electrónico para la aprobación de Habeas Data. Cuando se haya realizado la operación se podrá retomar la solicitud en el apartado “Mis solicitudes - Pendientes por radicar”."
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />

      <Copyright />
    </ClientRegistrationContainer>
  )
}

export default ClientRegistrationPage;
